module.exports = {
  title: 'Color Picker with React Native Skia',
  author: 'Enzo Manuel Mangano',
  date: '2023-10-18',
  slug: 'skia-color-picker',
  tags: ['skia', 'gesture-handler'],
};
